import React from 'react';
import clsx from 'clsx';

type ButtonStyle = 'primary' | 'light';

export type ButtonProps = {
  disabled?: boolean;
  className?: string;
  style?: ButtonStyle;
  children: React.ReactNode;

  onClick?: () => void;
};

const styleMap: { [x in ButtonStyle]: string } = {
  light: 'bg-content hover:bg-active text-text',
  primary: 'bg-active text-text',
};

const Button: React.FC<ButtonProps> = ({
  style = 'light',
  disabled,
  className,
  onClick,
  children,
}) => {
  return (
    <button
      onClick={!disabled ? onClick : undefined}
      className={clsx(
        className,
        styleMap[style],
        disabled ? 'disabled opacity-40 pointer-events-none' : '',
        'inline-flex items-center justify-center gap-x-sm',
        'px-2xl py-sm font-medium text-small shadow-md rounded-sm border border-active',
        'transition-default'
      )}
    >
      {children}
    </button>
  );
};

export default React.memo(Button) as typeof Button;
